(function () {
  'use strict';
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      if (typeof window.refreshCartUI === 'function') {
        window.refreshCartUI();
      }
    }
  });

  function patchVibeAccessibility() {
    var count = 1;
    document.querySelectorAll('vibe-feed').forEach(function (vFeed) {
      vFeed.querySelectorAll('vibe-item img.vibe-img').forEach(function (img) {
        if (document.querySelector('img.vibe-img[alt="Instagram ' + count + '"]')) {
          count++;
        }
        img.alt = 'Instagram ' + count;
        count++;
      });

      for (var i = 1; i <= 6; i++) {
        vFeed.querySelectorAll('h' + i).forEach(function (el) {
          if (!el.textContent.trim()) el.remove();
        });
      }
      vFeed.querySelectorAll('a:not([aria-label])').forEach(function (el) {
        el.setAttribute('aria-label', 'link');
      });
    });
    document.querySelectorAll('vibe-modal').forEach(function (vModal) {
      var map = {
        'button.vibe-modal-close': 'Instagram close button',
        'button.vibe-bnp': 'Instagram slider previous button',
        'button.vibe-bnn': 'Instagram slider next button',
      };
      Object.keys(map).forEach(function (sel) {
        var btn = vModal.querySelector(sel);
        if (btn) btn.setAttribute('aria-label', map[sel]);
      });

      vModal.querySelectorAll('.vibe-slide img').forEach(function (img, index) {
        if (!img.getAttribute('alt')) {
          img.setAttribute('alt', 'Instagram Slide ' + (index + 1));
        }
      });

      for (var i = 1; i <= 6; i++) {
        vModal.querySelectorAll('h' + i).forEach(function (el) {
          if (!el.textContent.trim()) el.remove();
        });
      }
      vModal.querySelectorAll('a:not([aria-label])').forEach(function (el) {
        el.setAttribute('aria-label', 'link');
      });
    });
  }

  if (document.readyState !== 'loading') {
    patchVibeAccessibility();
  } else {
    document.addEventListener('DOMContentLoaded', patchVibeAccessibility);
  }
  window.addEventListener('load', function () {
    setTimeout(patchVibeAccessibility, 1000);
  });
})();